/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-12-28 15:44:43
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';

import './index.css'
import BsyLocation from '../BsyLocation';

import BsySubformBase from '../BsySubformBase';

class BsySubformLocation extends BsySubformBase {

    constructor(props) {
        super({
            baseCls: "bsy-subform-location",
            allowBlank: !0,
            locationText: React.language("widget.location.get"),
            hasBrief: !0,
            btnWidth: 350,
            btnHeight: 34,
            isValueVisible: !0,
            enablePcLocation: !1,
            ...props
        });

        this.element = React.createRef();
    }

    getValue = () => {
        const { value } = this.state
        return value
    }

    componentDidMount() {
        super.componentDidMount()

    }

    getAddressContext = (context) => {
        const { items, value } = this.state;
        this.addressContext = context;
        context.setValue(value)
    }
    popUpPane = () => {
        const { items, value } = this.state;
        const { hasBrief, btnWidth, btnHeight, isValueVisible, enablePcLocation } = this.options;
        let that = this;
        return <BsyLocation
            getContext={that.getAddressContext}
            format={this.props.format}
            value={value}
            width={"auto"}
            locationText={React.language("widget.location.get")}
            hasBrief={hasBrief}
            btnWidth={btnWidth}
            btnHeight={btnHeight}
            isValueVisible={isValueVisible}
            enablePcLocation={enablePcLocation}
            onStopEdit={(e) => {
                that.setState({
                    value: { ...e },
                }, () => {
                    // BsyUtils.applyFunc(that, that.props.onStopEdit, [e, null, that], !1)
                    // ref.closeAlter();
                })
            }}
        ></BsyLocation>
    }

    popUpPaneClose = (e) => {
        let that = this;
        let value = that.addressContext.getValue();
 
        if(BsyUtils.closestClass(e.target,'x-dialog')) {
            return !0;
        }

        //由于弹出层关闭的时间比 控制触发焦点的时间要快，所以只能在关闭的时候取地址的值
        that.value = { ...value }
        that.setState({
            value: value
        }, () => {

            BsyUtils.applyFunc(that, that.props.onStopEdit, [value, null, that], !1)
        })

       

        this.addressContext = null;
        return !1;
    }

    renderDisablePane = () => {
        const { value } = this.state
        let valstr = BsyUtils.address2Str(value, 'pcda')
        return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')} title={valstr} >{valstr}</div>

    }



    render() {
        const { value } = this.state
        const { cssName, css, } = this.options;

        if (!this.isEnabled()) {
            return this.renderDisablePane()
        }
        let valstr = BsyUtils.address2Str(value, 'pcda', '-')
        return (
            <div className={cssName}
                style={css}
                ref={this.element}
                onClick={(e) => {
                    this._onTriggerClick(e, 340)
                }}
            >
                <div className="select-trigger">
                    <span className="select-val">{valstr}</span>
                    {
                        this.renderBtn('icon-widget-location', valstr)
                    }
                </div>
            </div>
        );
    }
}

export default BsySubformLocation;